import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';

export const SUB_PRODUCTS_X_PADDING = 4;

export const StyledMainSubBundle = styled.div`
  --size-diff: 1.2;
  height: 100%;

  &.main-sub-bundle {
    &--regular {
      .products {
        min-height: calc(100% - 30px);

        .main-product {
          height: 66px;
          padding: 0 8px;
          box-sizing: border-box;

          .quantity {
            font-size: 20px;
            white-space: nowrap !important;
          }

          &__header {
            &__prefix-img {
              height: 18px;
              width: 18px;
            }
          }
        }
      }

      .sub-items-grid {
        height: 102px;
      }

      .scroller {
        height: calc(100% - 72px);
      }
    }

    //---------------
    &--big {
      .products {
        min-height: calc(100% - 40px);

        .main-product {
          height: 82px;
          display: flex;
          padding: 0 8px;
          box-sizing: border-box;
        }

        .quantity {
          font-size: 24px;
        }

        &__header {
          &__prefix-img {
            height: 22px;
          }
        }
      }

      .sub-items-grid {
        height: 122px;

        .content-container p {
          font-size: 15px;

          &.tooltip {
            font-size: 13px;
          }
        }
      }

      .scroller {
        height: calc(100% - 87px);
      }

      .product-image-container {
        transform: scale(var(--size-diff));
        padding: 0 7px;
      }
    }
  }

  margin: 0 auto;
  border-radius: ${(props: any) => `${props.borderRadius || 15}px`};
  padding: 3px;
  background: ${(props: any) => createGradientOrSolid(props.bundleBorderColor)};
  font-family: ${(props: any) => props.fontFamily};
  position: relative;

  .container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .scroller {
    right: 0;
    bottom: 0;
    box-shadow: inset -26px 0px 16px -12px #def7ff;
    width: 50px;
    position: absolute;
    z-index: 10000;

    > button {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      border: 0;
      position: relative;
      background: #78c1e7;
      box-shadow: 0 2px 3px 0 #0b4969;
      left: 35px;
      top: calc(50% - 12px);
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .products {
    border-top-left-radius: ${(props: any) => `${props.borderRadius || 15}px`};
    border-top-right-radius: ${(props: any) => `${props.borderRadius || 15}px`};
    display: flex;
    flex-direction: column;
    background: ${(props: any) =>
      props.backgroundSrc
        ? `url("${props.backgroundSrc}")`
        : createGradientOrSolid(props.backgroundColor)};
    background-size: 100% 100%;
    position: relative;

    & > div:not(.scroller) {
      &.sub {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        position: relative;
        padding: 10px 4px 4px 4px;
      }
    }
  }

  .sub-items-grid {
    width: auto;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-auto-flow: column;
    overflow-x: hidden;
    overflow-y: hidden;
    padding: 10px ${SUB_PRODUCTS_X_PADDING}px 4px ${SUB_PRODUCTS_X_PADDING}px;

    > div {
      display: flex;
      width: 100%;
      white-space: nowrap;
      justify-content: center;
      align-items: center;
      padding: 0;
      margin: 0;
    }
  }

  span {
    text-shadow: 0px 2px 0px #000000;

    &.availability {
      position: absolute;
      bottom: 10px;
      font-size: 12px;
      font-weight: 600;

      &.quantity {
        left: 15px;
      }
    }
  }

  .sub-product--amount {
    flex-direction: column;
    width: 100%;
    max-width: 130px;
  }

  .bundlePriceButton {
    height: 32px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    .bundlePriceButton {
      height: 40px;
    }

    &.bundle--iphone-mock {
      .bundlePriceButton {
        height: 32px;
      }
    }
  }
` as any;
